import { Link } from "@StarberryUtils";
import * as React from "react"
import { Button, Container, Row, Col, Accordion, Card, useAccordionToggle } from "react-bootstrap"
//import ScrollAnimation from "react-animate-on-scroll";
import HTMLReactParser from 'html-react-parser';
import { useStaticQuery, graphql } from "gatsby";
import Slider from "react-slick";
import { useContext } from "react"
import AccordionContext from "react-bootstrap/AccordionContext"
import "./Information.scss"

// markup
const InformationList = () => {

    const data = useStaticQuery(graphql`
    query {
      glstrapi {
	    globalModule { 
            Useful_Informations {
                Description
                Title
            }  
	    }
      }
    }
  `);

    const content = data.glstrapi.globalModule
    function CustomToggle({ children, eventKey, callback }) {
        const currentEventKey = useContext(AccordionContext);
        const decoratedOnClick = useAccordionToggle(eventKey, () =>
            eventKey,
            () => callback && callback(eventKey),
        );
        const isCurrentEventKey = currentEventKey === eventKey;
        return (
            <div

                className="card-header"
                onClick={decoratedOnClick}
            >
                <i className={isCurrentEventKey ? 'icon-show' : 'icon-plus'}> </i>
                {/* <i className="icon-show"> </i> */}
                {children}
            </div>
        );
    }
    return (
        <React.Fragment>
            <section className="information">
                <div animateIn='fadeInUp' >
                    <div className="d-xl-block">
                        <h2>Useful Information</h2> 
                        <Accordion defaultActiveKey="0">
                            {content.Useful_Informations && content.Useful_Informations.map((card, i) => {
                                return (<Card>
                                    <CustomToggle as={Card.Header} eventKey={i + 1}>  {card.Title}
                                    </CustomToggle>

                                    <Accordion.Collapse eventKey={i + 1}>
                                        <Card.Body>

                                            {HTMLReactParser(card.Description.replace(/\n/g, '<br />'))}
                                        </Card.Body>
                                    </Accordion.Collapse>
                                </Card>)
                            })}
                        </Accordion>
                    </div>
                </div>
            </section>
        </React.Fragment>
    )
}
export default InformationList